import React from 'react';
import { useLocation } from 'react-router-dom';
import { BellIcon, MagnifyingGlassIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { ThemeToggle } from '../ThemeToggle';

interface HeaderProps {
  onMenuClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const location = useLocation();

  // Obter título baseado na rota
  const getPageTitle = () => {
    const path = location.pathname;
    if (path === '/') return 'Dashboard';
    if (path === '/users') return 'Usuários';
    if (path === '/companies') return 'Empresas';
    if (path === '/analytics') return 'Analytics';
    if (path === '/settings') return 'Configurações';
    if (path === '/logs') return 'Logs';
    if (path === '/security') return 'Segurança';
    return 'Dashboard';
  };

  return (
    <header 
      className="border-b px-4 sm:px-6 py-3 sm:py-4"
      style={{ 
        backgroundColor: 'var(--header-bg)',
        borderColor: 'var(--border-primary)'
      }}
    >
      <div className="flex items-center justify-between">
        {/* Left side - Menu button (mobile) + Title */}
        <div className="flex items-center space-x-3 sm:space-x-4">
          {/* Menu button - apenas mobile */}
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg transition-colors duration-200"
            style={{
              color: 'var(--text-muted)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--text-primary)';
              e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--text-muted)';
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            aria-label="Abrir menu"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>

          {/* Page title */}
          <h2 
            className="text-lg sm:text-xl font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            {getPageTitle()}
          </h2>
        </div>

        {/* Right side */}
        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* Search - escondido em telas muito pequenas */}
          <div className="hidden sm:block relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon 
                className="h-5 w-5" 
                style={{ color: 'var(--text-muted)' }}
              />
            </div>
            <input
              type="text"
              placeholder="Buscar..."
              className="block w-48 lg:w-64 pl-10 pr-3 py-2 border rounded-lg leading-5 text-sm focus:outline-none"
              style={{
                borderColor: 'var(--input-border)',
                backgroundColor: 'var(--input-bg)',
                color: 'var(--text-primary)',
              }}
            />
          </div>

          {/* Search icon button - apenas mobile */}
          <button 
            className="sm:hidden p-2 rounded-lg transition-colors duration-200"
            style={{ color: 'var(--text-muted)' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--text-primary)';
              e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--text-muted)';
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <MagnifyingGlassIcon className="h-5 w-5" />
          </button>

          {/* Theme Toggle */}
          <ThemeToggle />

          {/* Notifications */}
          <button 
            className="relative p-2 rounded-lg transition-colors duration-200"
            style={{ color: 'var(--text-muted)' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--text-primary)';
              e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--text-muted)';
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <BellIcon className="h-5 w-5 sm:h-6 sm:w-6" />
            <span className="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-400"></span>
          </button>

          {/* Quick Actions - escondido em mobile */}
          <div className="hidden md:flex items-center space-x-2">
            <button className="btn-primary text-sm whitespace-nowrap">
              Nova Ação
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
